import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/glow-1.png")